function FooterLogo() {
  return (
    <div className="footer-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="14"
        viewBox="0 0 152 14"
        fill="none"
      >
        <path
          d="M8.11988 2.61254C8.86142 2.61254 9.46255 2.0277 9.46255 1.30627C9.46255 0.584831 8.86142 0 8.11988 0C7.37833 0 6.7772 0.584831 6.7772 1.30627C6.7772 2.0277 7.37833 2.61254 8.11988 2.61254Z"
          fill="white"
        />
        <path
          d="M14.8759 11.3831C14.1343 11.3831 13.5332 11.968 13.5332 12.6894C13.5332 13.4108 14.1343 13.9957 14.8759 13.9957C15.6174 13.9957 16.2186 13.4108 16.2186 12.6894C16.2186 11.968 15.6174 11.3831 14.8759 11.3831Z"
          fill="white"
        />
        <path
          d="M1.34268 11.3831C0.601135 11.3831 0 11.968 0 12.6894C0 13.4108 0.601135 13.9957 1.34268 13.9957C2.08422 13.9957 2.68536 13.4108 2.68536 12.6894C2.68536 11.968 2.08422 11.3831 1.34268 11.3831Z"
          fill="white"
        />
        <path
          d="M8.07983 4.35426C7.49596 6.79954 5.94332 8.3063 3.43115 8.86377V8.91966C5.95274 9.47845 7.51085 10.9984 8.08401 13.4567H8.14133C8.71312 11.0075 10.2578 9.49297 12.766 8.92373V8.85969C10.2671 8.29183 8.72796 6.79039 8.1455 4.35426H8.07983Z"
          fill="white"
        />
        <path
          d="M96.4868 13.7084V0H98.4267V5.81393H105.426V0H107.386V13.7084H105.426V7.50561H98.4267V13.7084H96.4868Z"
          fill="white"
        />
        <path
          d="M134.666 13.7084C133.066 13.7084 132.306 12.8529 132.306 11.4723V0H134.166V11.3556C134.166 11.9779 134.466 12.2112 135.046 12.2112H135.426V13.7084H134.666Z"
          fill="white"
        />
        <path
          d="M143.36 13.7084V0H145.24V5.26949C145.58 4.74448 146.54 3.79169 148.34 3.79169C150.46 3.79169 152 5.05559 152 7.42783V13.7084H150.12V7.77783C150.12 5.95004 149.24 5.26949 147.84 5.26949C145.98 5.26949 145.24 6.70838 145.24 8.5945V13.7084H143.36Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.902 8.88601C119.902 11.8999 121.842 13.9999 124.782 13.9999C126.981 13.9999 128.121 12.6583 128.341 12.3083V13.7083H130.161V4.0832H128.341V5.34711C127.861 4.68599 126.701 3.79153 124.762 3.79153C121.822 3.79153 119.902 5.94988 119.902 8.88601ZM125.102 12.4833C123.102 12.4833 121.822 11.0638 121.822 8.88601C121.822 6.70822 123.102 5.30821 125.102 5.30821C127.061 5.30821 128.421 6.72766 128.421 8.88601C128.421 11.0833 127.061 12.4833 125.102 12.4833Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80.5159 8.88608C80.5159 11.9 82.4558 14 85.3956 14C87.5955 14 88.7354 12.6583 88.9554 12.3083V13.7083H90.7753V4.08328H88.9554V5.34718C88.4755 4.68605 87.3155 3.79161 85.3756 3.79161C82.4358 3.79161 80.5159 5.94995 80.5159 8.88608ZM85.7156 12.4833C83.7157 12.4833 82.4358 11.0639 82.4358 8.88608C82.4358 6.70829 83.7157 5.30829 85.7156 5.30829C87.6755 5.30829 89.0354 6.72774 89.0354 8.88608C89.0354 11.0833 87.6755 12.4833 85.7156 12.4833Z"
          fill="white"
        />
        <path
          d="M70.4193 13.7083V4.08328H72.2392V5.38606C72.5592 4.84162 73.5592 3.79161 75.3991 3.79161C77.519 3.79161 79.0589 5.05551 79.0589 7.42775V13.7083H77.199V7.66108C77.199 5.91107 76.299 5.28884 74.9391 5.28884C73.0392 5.28884 72.2992 6.74718 72.2992 8.67219V13.7083H70.4193Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.262 8.88608C58.262 11.9 60.2018 14 63.1417 14C65.3416 14 66.4815 12.6583 66.7015 12.3083V13.7083H68.5214V4.08328H66.7015V5.34718C66.2215 4.68605 65.0616 3.79161 63.1217 3.79161C60.1818 3.79161 58.262 5.94995 58.262 8.88608ZM63.4617 12.4833C61.4618 12.4833 60.1818 11.0639 60.1818 8.88608C60.1818 6.70829 61.4618 5.30829 63.4617 5.30829C65.4216 5.30829 66.7815 6.72774 66.7815 8.88608C66.7815 11.0833 65.4216 12.4833 63.4617 12.4833Z"
          fill="white"
        />
        <path
          d="M52.4268 13.7085V4.08343H54.2467V5.89176C54.6666 5.0751 55.6666 3.98621 57.5465 3.98621H57.8265V5.81399H57.3265C55.1466 5.81399 54.3067 7.05844 54.3067 8.96401V13.7085H52.4268Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.4597 0L21.7744 13.7228H23.8637C24.7677 11.3115 26.4552 10.1549 28.5846 10.1353C30.915 10.1353 32.5422 11.2919 33.4262 13.7228H35.636L29.8101 0H27.4597ZM28.6047 8.46895C27.3994 8.46895 26.3949 8.88063 25.5512 9.37074L28.5846 1.62714L31.6985 9.37074C30.915 8.88063 29.8101 8.46895 28.6047 8.46895Z"
          fill="white"
        />
        <path
          d="M40.4383 13.9954C38.0853 14.0134 36.7827 12.8987 36.113 11.3706L37.7315 10.7233C37.9734 11.4425 38.8383 12.5392 40.4197 12.5392C41.815 12.5392 42.6803 11.9638 42.6803 11.1548C42.6803 10.4177 42.2338 9.98618 40.5966 9.69852L39.6664 9.53672C37.1548 9.10523 36.4851 8.08044 36.4851 6.66012C36.4851 5.07799 38.0106 3.81948 40.1687 3.81948C42.3268 3.81948 43.6105 4.71841 44.1872 5.94097L42.5686 6.5882C42.2338 5.76119 41.3966 5.27576 40.1501 5.27576C38.9036 5.27576 38.2153 5.8331 38.2153 6.53426C38.2153 7.23544 38.792 7.59501 40.2245 7.84671L41.2291 8.0265C43.4616 8.42203 44.6151 9.39289 44.6151 11.0649C44.6151 12.7369 43.1173 13.9775 40.4383 13.9954Z"
          fill="white"
        />
        <path
          d="M46.7557 10.7333C46.7557 12.65 47.7378 13.6956 49.4815 13.6956H50.9847V12.1466H50.0627C49.1407 12.1466 48.6196 11.8175 48.6196 10.7913V5.50569H50.9847V4.11165H48.6196V1.69148H47.1061L47.0648 2.3548C47.0002 3.45117 46.3408 4.21507 45.2645 4.35168L44.9518 4.39564V5.50569H46.7557V10.7333Z"
          fill="white"
        />
        <path
          d="M140.199 13.6956C138.455 13.6956 137.473 12.65 137.473 10.7333V5.50569H135.669V4.39564L135.982 4.35168C137.058 4.21507 137.718 3.45117 137.782 2.3548L137.824 1.69148H139.337V4.11165H141.702V5.50569H139.337V10.7913C139.337 11.8175 139.858 12.1466 140.78 12.1466H141.702V13.6956H140.199Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M108.956 8.91215C108.956 11.955 110.869 13.9957 113.983 13.9957C116.608 13.9957 117.959 12.6109 118.484 11.4266L116.796 10.8071C116.383 11.7181 115.483 12.5016 113.945 12.5016C112.126 12.5016 110.888 11.3173 110.851 9.33122H118.596C118.784 6.06975 116.833 3.7922 113.814 3.7922C110.794 3.7922 108.956 5.86933 108.956 8.91215ZM116.627 7.94646H110.888C111.113 6.12442 112.145 5.23161 113.814 5.23161C115.239 5.23161 116.533 6.06975 116.627 7.94646Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default FooterLogo;
